import React from "react";
import { CheckCircle2Icon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CTAButtonProps = {
  label: string;
  note?: string;
  id?: string;
  tone?: "light" | "dark";
};
export function CTAButton({
  label,
  note,
  id,
  tone = "light"
}: CTAButtonProps) {
  return <div className="flex w-full flex-col items-center" data-id="element-99" data-mp="2fz20qldwwuuz">
      <a id={id} href={CHECKOUT_URL} className="flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[16px] font-extrabold uppercase leading-snug tracking-wide text-white shadow-[0_12px_30px_-10px_rgba(22,163,74,0.75)] ring-1 ring-inset ring-white/20 transition-[transform,background-color] duration-150 ease-out hover:bg-cta-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-gold active:scale-[0.97] sm:text-lg md:py-6" data-id="element-100" data-mp="2g1o8al0szad7">
        <CheckCircle2Icon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-101" data-mp="38o8z9kdd9kg8" />
        <span data-id="element-102" data-mp="38q3kkzsjveku">{label}</span>
      </a>
      {note && <p className={`mt-3 max-w-md text-center text-[13px] leading-relaxed sm:text-sm ${tone === "dark" ? "text-white/70" : "text-muted"}`} data-id="element-103" data-mp="199og8k7a9fuv">
          {note}
        </p>}
    </div>;
}